import { TeamMemberRole } from '@api'
import { useFormContext } from 'react-hook-form'

import type { TeamMemberEditFormValues } from '@/modules/team/views/edit/team-edit-form'

import { useTeamPermissions } from '../../../hooks/use-team-permissions'
import { PermissionsTableField } from '../../permissions-table-form'

interface Props {
  role: string
}

export const TeamMemberPermissionsForm = ({ role }: Props) => {
  const { control } = useFormContext<TeamMemberEditFormValues>()
  const {
    allPermissions,
    generalPermissions,
    ofPermissions,
    accessOnlyFansProfilePermission,
  } = useTeamPermissions()

  return (
    allPermissions && (
      <PermissionsTableField<TeamMemberEditFormValues>
        allPermissions={allPermissions}
        accessOnlyFansProfilePermission={accessOnlyFansProfilePermission}
        ofPermissions={ofPermissions}
        generalPermissions={generalPermissions}
        mode="MEMBER"
        isEditEnabled={role !== TeamMemberRole.ADMIN}
        control={control}
      />
    )
  )
}
